// Balanced, accessible chart palette. Chosen to remain legible on white
// backgrounds and keep adjacent hues distinguishable for color-vision deficiencies.
// Kept as a small constant array (not pulled from MUI theme) because chart.js
// consumes plain hex strings and we want stable colors across themes.

export const ANALYTICS_PALETTE: readonly string[] = [
  '#2563eb', // blue 600
  '#0d9488', // teal 600
  '#f59e0b', // amber 500
  '#ef4444', // red 500
  '#8b5cf6', // violet 500
  '#10b981', // emerald 500
  '#ec4899', // pink 500
];

export const ANALYTICS_GRID_COLOR = 'rgba(15, 23, 42, 0.08)';
export const ANALYTICS_AXIS_COLOR = 'rgba(15, 23, 42, 0.6)';
export const ANALYTICS_TOOLTIP_BG = 'rgba(15, 23, 42, 0.92)';
export const ANALYTICS_PIE_BORDER = '#fff';

export const getSeriesColor = (index: number): string =>
  ANALYTICS_PALETTE[index % ANALYTICS_PALETTE.length];

export const paletteFor = (labels: readonly unknown[]): string[] =>
  labels.map((_, idx) => getSeriesColor(idx));
